<template>
  <div>
    <el-dialog
      title="系统公告"
      width="50%"
      :visible.sync="show"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <div class="form-content">
        <el-form
          ref="noticeForm"
          :model="form"
          :rules="rules"
          label-width="140px"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="公告名称" prop="heading">
                <el-input
                  placeholder="请输入公告名称"
                  v-model="form.heading"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="正文内容" prop="body">
                <vue-ueditor-wrap
                  v-model="form.body"
                  :config="myConfig"
                ></vue-ueditor-wrap>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="发送地址" prop="send_obj">
                <el-radio-group v-model="form.send_obj">
                  <el-radio :label="0">用户端</el-radio>
                  <el-radio :label="1">管理端</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="编制人">
                <el-input
                  v-model="form.create_user"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间">
                <el-input
                  v-model="form.create_time"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="preview">预 览</el-button>
        <el-button type="primary" @click="handleSave" :loading="loading"
          >确 定</el-button
        >
        <el-button @click="handleClose">取 消</el-button>
      </div>
    </el-dialog>
    <notice-detail
      :show="noticeShow"
      :form="noticeFrom"
      @close="closeNotice"
    ></notice-detail>
  </div>
</template>

<script>
import utils from "@/utils";
import { mapState } from "vuex";
import noticeDetail from "@/views/system/components/noticeDetail.vue";
export default {
  components: { noticeDetail },
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    id: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      form: {
        heading: "",
        body: "",
        create_user: "",
        create_time: "",
        send_obj: 0
      },
      rules: {
        heading: [
          { required: true, message: "请输入公告名称", trigger: "blur" }
        ],
        body: [{ required: true, message: "请输入公告内容", trigger: "blur" }],
        send_obj: [
          { required: true, message: "请选择发送地址", trigger: "change" }
        ]
      },
      loading: false,
      myConfig: {
        initialFrameHeight: 240,
        UEDITOR_HOME_URL: "/ueditor/",
        // UEDITOR_HOME_URL: window.location.origin +'/'+ window.location.pathname.split('/')[1]+'/ueditor/',
        toolbars: [
          [
            "source",
            "undo", //撤销
            "bold", //加粗
            "indent", //首行缩进
            "italic", //斜体
            "underline", //下划线
            "strikethrough", //删除线
            "subscript", //下标
            "fontborder", //字符边框
            "superscript", //上标
            "formatmatch", //格式刷
            "fontfamily", //字体
            "fontsize", //字号
            "justifyleft", //居左对齐
            "justifycenter", //居中对齐
            "justifyright", //居右对齐
            "justifyjustify", //两端对齐
            "insertorderedlist", //有序列表
            "insertunorderedlist", //无序列表
            "lineheight", //行间距
            "forecolor", //字体颜色
            "simpleUpload"
          ]
        ],
        // 上传文件接口
        imageMaxSize: 2048000,
        imageAllowFiles: [".png", ".jpg", ".jpeg"],
        imageFieldName: "file",
        // 初始容器宽度
        initialFrameWidth: "100%",
        zIndex: 9001,
        enableAutoSave: false,
        readonly: false
      },
      noticeFrom: {},
      noticeShow: false
    };
  },
  mounted() {
    this.form.create_user_id = this.currentUserDetail.user.userId;
    this.form.create_user = this.currentUserDetail.user.fullname;
    this.form.create_time = utils.formatDate(new Date());
    if (this.id && this.id != "") {
      this.$http.get("${business}/system/sys_bulletin/" + this.id).then(res => {
        if (res.data) {
          this.form = res.data;
        }
      });
    }
  },
  computed: {
    ...mapState({
      currentUserDetail: state => state.user.currentUserDetail
    })
  },
  methods: {
    //表单预览
    preview() {
      if (this.form.heading && this.form.body) {
        this.noticeFrom = {
          subject: this.form.heading,
          content: this.form.body
        };
        this.noticeShow = true;
      } else {
        this.$message.info("请先输入公告名称和正文内容！");
      }
    },
    closeNotice() {
      this.noticeShow = false;
    },
    //关闭表单
    handleClose() {
      this.$emit("close");
    },
    //提交表单
    handleSave() {
      this.$refs.noticeForm.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.id && this.id != "") {
            this.$http
              .put("${business}/system/sys_bulletin/", this.form)
              .then(res => {
                if (res.data.state) {
                  this.$message.info("保存成功！");
                }
                this.loading = false;
                this.handleClose();
              });
          } else {
            this.$http
              .post("${business}/system/sys_bulletin/", this.form)
              .then(res => {
                if (res.data.state) {
                  this.$message.info("保存成功！");
                }
                this.loading = false;
                this.handleClose();
              });
          }

          setTimeout(() => {
            this.loading = false;
          }, 1000);
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped></style>
